import DropLoad from "./DropLoad.js";

export default DropLoad
